var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100" },
    [
      _c("ReplyCreate", {
        staticClass: "mt-3",
        attrs: { comment: _vm.comment, show: _vm.replyCreate },
        on: {
          toggleReplyCreate: _vm.toggleReplyCreate,
          replyCreated: _vm.replyCreated,
        },
      }),
      _vm._v(" "),
      _vm.count
        ? _c("div", [
            _vm.showReplies && _vm.comment.replies
              ? _c(
                  "div",
                  _vm._l(_vm.comment.replies, function (reply) {
                    return _c("Reply", {
                      key: reply.id,
                      staticClass: "mt-3",
                      attrs: { comment: _vm.comment, reply: reply },
                      on: {
                        replyCreated: _vm.replyCreated,
                        replyRemoved: _vm.replyRemoved,
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.toggleReplies.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.showReplies
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("translate")("Hide")) +
                            " " +
                            _vm._s(_vm._f("translate")("replies"))
                        ),
                      ])
                    : _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("translate")("Show")) +
                            " " +
                            _vm._s(_vm._f("translate")("replies")) +
                            " (" +
                            _vm._s(_vm.comment.replies_count) +
                            ")"
                        ),
                      ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }